import { createAuthProvider } from "react-token-auth";
import axios from "axios";

const BackendLoginService = (function () {
  var instance;

  var isLoggedIn = false;

  const api = axios.create({
    baseURL: "/api",
  });

  const customFetch = (url, config) => {
    config.url = url;
    return api.request(config);
  };

  // function handleFetchErrors(response) {
  //   if (!response.ok) {
  //     throw Error(response.statusText);
  //   }
  //   return response;
  // }

  const [
    useAuth,
    authFetch,
    loginInternal,
    logoutInternal,
  ] = createAuthProvider({
    accessTokenKey: "jwtToken",
    customFetch: customFetch,
    onUpdateToken: (token) =>
      api
        .post("/Auth/refresh", JSON.stringify(token.refreshToken), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((r) => {
          return r.data;
        })
        .catch((error) => {
          isLoggedIn = false;
          let message = "";
          if (error.response) {
            if (error.response.status === 403) {
              throw new Error("Refresh token is outdated");
            }
            message = `${error.response.status} ${
              error.response.statusText
            }\n${JSON.stringify(error.response.data)}`;
            // Request made and server responded
            console.log(error.response);
          } else if (error.request) {
            message = "no response";
            console.log(error.request);
          } else {
            message = error.message;
            console.log("Error", error.message);
          }
          throw new Error(message);
        }),
    // onUpdateToken: (token) =>
    //   fetch("/api/Auth/refresh", {
    //     method: "POST",
    //     body: JSON.stringify(token.refreshToken),
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   })
    //     .then(handleFetchErrors)
    //     .then((r) => r.json())
    //     .catch((error) => {
    //       console.log(error);
    //     }),
  });

  const authGet = (url, config) => {
    config = config || {};
    config.method = "get";

    return authFetch(url, config);
  };

  const authPost = (url, data, config) => {
    config = config || {};
    config.method = "post";
    config.data = data;

    return authFetch(url, config);
  };

  const authPut = (url, data, config) => {
    config = config || {};
    config.method = "put";
    config.data = data;

    return authFetch(url, config);
  };

  const authDelete = (url, config) => {
    config = config || {};
    config.method = "delete";

    return authFetch(url, config);
  };

  const login = (googleResponse) => {
    return api
      .post("/Auth/google", googleResponse)
      .then((r) => {
        loginInternal(r.data);
        isLoggedIn = true;
        return r.data;
      })
      .catch((error) => {
        let message = "";
        if (error.response) {
          message = `${error.response.status} ${
            error.response.statusText
          }\n${JSON.stringify(error.response.data)}`;
          // Request made and server responded
          console.log(error.response);
        } else if (error.request) {
          message = "no response";
          console.log(error.request);
        } else {
          message = error.message;
          console.log("Error", error.message);
        }
        throw new Error(message);
      });
  };

  // const login = (googleResponse) => {
  //   return fetch("/api/Auth/google", {
  //     method: "POST",
  //     body: JSON.stringify(googleResponse),
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then(handleFetchErrors)
  //     .then((r) => r.json())
  //     .then((r) => {
  //       loginInternal(r);
  //       isLoggedIn = true;
  //       return r;
  //     });
  // };

  const logout = () => {
    logoutInternal();
    isLoggedIn = false;
  };

  const isLoggedInFun = () => {
    return isLoggedIn;
  };

  const createInstance = function () {
    return {
      login,
      authGet,
      authPost,
      authPut,
      authDelete,
      logout,
      isLoggedIn: isLoggedInFun,
    };
  };

  return {
    getInstance: function () {
      return instance || (instance = createInstance());
    },
  };
})();

export default BackendLoginService;
